$(function() 
{

  if($('.multistep-form').length > 0) {
    setupMultistepForm();
  }
  
});

//Form settup
function setupMultistepForm() {

  $('#terms').hide();

  setupMultistepFormOtherFunctions();

  createSummraryTable();
  $('.summrary-group').hide();

  toggleIsRequiredError(false);
  
  setupStepMovementButtons();
  setupStepMovementWithKeyboard();

  showStep(1);

}

function toggleFinishMultistepForm(isFinished) {

  if(isFinished) 
  {

    var dissableSummraryTable = $('.multistep-form').attr('data-dissableSummraryTable');
    if(dissableSummraryTable == 0) 
    {
      $('.multistep-form').attr('data-isFinished', 1);

      $('.summrary-group').show();
    
      $('.steps-group').hide();
      toggleNextButton(false);
    } 
    else 
    {
      areTermsAccepted = $('.terms-input').length == 0 || ($('.terms-input').length > 0 &&  $('.terms-input').prop('checked') == true);
      if(areTermsAccepted) 
      {
        $('.steps-group').hide();
        $('.multistepFormContainer').hide();
    
        $('.spinner-container').show();
    
        toggleNextButton(false);
        toggleBackButton(1);
          
        $('.submit-button').click();
      }
 
    }
  } 
  else 
  {
    $('.multistep-form').attr('data-isFinished', 0);

    $('.summrary-group').hide();
  
    $('.steps-group').show();
    toggleNextButton(true);
  }

}

function getAllSteps() {
  
  var form = $('.multistep-form');
  return $('.step', form);

}



// Next and Back buttons - step movement
function setupStepMovementButtons() {

  var finalStep = getAllSteps().length;

  $('.next-button').on('click', function() {

    setAnotherStep(finalStep, true, true);

  });

  $('.back-button').on('click', function() {
  
    var currentStep = $('.step[data-isStepShown=1]');
    var currentStepNumber = currentStep.attr('data-stepNumber');

    if(currentStepNumber > 1) {
      setAnotherStep(finalStep, false, false);
    } 
    // Only for publicContestMultistep
    else 
    {
      $('.contestVersionInput').val($('.contest-version-switch').attr('data-appVersionStandard'));
      $('.for-visually-impaired').hide();

      $('.show-multistep-container').show();
      $('.bigFooterContainer').show();
      $('.footer').css('margin-top', 150); 
      $('#mainNavLine').show();

      if ($(window).width() >= 768) {
        $('.sub-navbar').show();
      }
  

      $('.show-multistep-container').show();
      $('.multistepFormContainer').hide();
    }
    

  });

}

function setAnotherStep(finalStep, isRequiereDemanded, isNextStep) {

  var currentStep = $('.step[data-isStepShown=1]');
  var currentStepNumber = currentStep.attr('data-stepNumber');

  if(isStepEmpty(currentStep) && isRequiereDemanded) {
    toggleIsRequiredError(true);
  } 
  else 
  {
    toggleIsRequiredError(false);

    if(validateStepValue(currentStep) === true || isNextStep == false) 
    {
      removeMultistepFormErrors();

      hideCurrentStep(currentStep, currentStepNumber, finalStep);


      if(isNextStep) 
      {
        addToSummrary(currentStep);
        anotherStepNumber = (parseInt(currentStepNumber) + 1);
      } 
      else 
      {
        anotherStepNumber = (parseInt(currentStepNumber) - 1);
      }

      var form = $('.multistep-form');
      if(anotherStepNumber <= finalStep) {
        showStep(anotherStepNumber);

        dissableSummraryTable = form.attr('data-dissableSummraryTable');

        if(dissableSummraryTable && parseInt(anotherStepNumber) == parseInt(finalStep)) 
        {
          $('.next-button').text(form.attr('data-finishBtnText'));
          $('#terms').show();
        } 
        else 
        {
          $('.next-button').text(form.attr('data-continueBtnText'));
          $('#terms').hide();
        }

      } 
      else {
        toggleFinishMultistepForm(true);
      }

      isFinished = form.attr('data-isFinished');
      if(isFinished == 1 && isNaN(anotherStepNumber)) 
      {
        showStep(finalStep);
        toggleFinishMultistepForm(false);
      }

    }
    else {
      addMultistepFormError(currentStep.attr('data-validationKey'));
    }

  }
}

function hideCurrentStep(currentStep, currentStepNumber, finalStep) {
  
  if(currentStepNumber == finalStep) 
  {
    areTermsAccepted = $('.terms-input').length == 0 || ($('.terms-input').length > 0 &&  $('.terms-input').prop('checked') == true);
    if(areTermsAccepted) 
    {
      currentStep.removeAttr('data-isStepShown');
      currentStep.hide();
    } 
    else 
    {
      $('.submit-button').click();
    }
  } 
  else 
  {
    currentStep.removeAttr('data-isStepShown');
    currentStep.hide();
  }

}


function toggleBackButton(stepNumber) {

  $('.back-button').show();

  // if(stepNumber > 1) {
  //   $('.back-button').show();
  // } else {
  //   $('.back-button').hide();
  // }

}

function toggleNextButton(show) {

  if(show) {
    $('.next-button').show();
    $('.buttons-container').css('margin-top', '20px');
  } 
  else 
  {
    $('.next-button').hide();
    $('.buttons-container').css('margin-top', '0px');
  }

}

function setupStepMovementWithKeyboard() {

  window.addEventListener('keypress', function(event) {

    if(event.key === 'Enter') 
    {  
      isFinished = $('.multistep-form').attr('data-isFinished');
      event.preventDefault();

      if(isFinished == 0) {
        $('.next-button').click();
      } else {
        $('.submit-button').click();
      }
    }

  });

}



// Step handling
function showStep(stepNumber) {

  var steps = getAllSteps();

  hideAllSteps(steps);


  finalStep = getAllSteps().length;
  if(stepNumber == finalStep) 
  {
    $('#terms').show();
    $('.next-button').text($('.multistep-form').attr('data-finishBtnText'));
  }


  var stepToShow = $('.step-' + stepNumber);
  
  stepToShow.attr('data-isStepShown', 1);
  stepToShow.show();

  $('.step-input input, .step-input textarea, .step-input select', stepToShow)[0].focus();

  toggleBackButton(stepNumber);

}

function hideAllSteps(steps) {

  steps.each(function(index, element) {

    $(element).hide();
    $(element).removeAttr('data-isstepshown');

  });

}



// Summrary table
function createSummraryTable() {

  getAllSteps().each(function(index, step) {
    
    addToSummrary(step);

  });

}

function addToSummrary(step) {

  var summraryTable = $('.summrary-table')[0];

  var stepNumber = $(step).attr('data-stepNumber');
  
  var stepRow = $('.step-row-' + stepNumber, summraryTable);
  

  if(stepRow.length === 0) 
  {
    var stepRow = summraryTable.insertRow();
    $(stepRow).addClass('step-row-' + stepNumber); 
  
    var cell1 = stepRow.insertCell(0);
    var cell2 = stepRow.insertCell(1);
  } 
  else 
  {
    var cells = $(stepRow).find('td');

    var cell1 =  cells[0]
    var cell2 = cells[1];  
  }

  var stepTitleText = $('.step-title', step).text();
  var stepInputText = getMultistepFormInputValues(step, false);


  cell1.innerHTML = stepTitleText;
  cell2.innerHTML = stepInputText;

}

function getMultistepFormInputValues(step, validate) {

  var stepInputs = $('input, textarea, select :selected', step);


  var inputText = "";
  var isValid = true;

  stepInputs.each(function(index, element) 
  {  
    if($(element)[0].tagName === "OPTION") 
    {
      value = $(element).text();
    } 
    else 
    {
      if($(element).attr('type') === 'date') 
      {
        var DateValue = new Date($(element).val());

        value = 
          ('0' + DateValue.getDate()).slice(-2) + '.' + 
          ('0' + (DateValue.getMonth()+1)).slice(-2) + '.' + 
          DateValue.getFullYear();
      } 
      else 
      {
        value = $(element).val();
      }
    }


    if(validate == true) {
      isValid = isStepValueValid($(element), value);
      
      if(isValid == false) {
        return false;
      }
    }


    if($(element).hasClass('hour')) 
    {
      inputText = inputText + value + ":";
    } else {
      inputText = inputText + value + " ";
    }

  });

  if(validate == true) {
    return isValid;
  }

  return inputText;
}



//Step values validation
function isStepEmpty(step) {

  var returnValue = false;
  if(step.hasClass('required')) 
  {
    var stepInputs = $('input, textarea, select :selected', step);
    
    stepInputs.each(function(index, element) 
    {  
      if($(element).val() == undefined || $(element).val() == null || $(element).val() == "") 
      {
        returnValue = true;
      }
    });
  } 
  else 
  {
    returnValue = false;
  }

  return returnValue;
}

function validateStepValue(step) {
  return getMultistepFormInputValues(step, true);
}

function isStepValueValid(input, value) {

  if(input.hasClass('email')) 
  {
    return (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value));
  }

  return true;
}



// Errors handling
function toggleIsRequiredError(show) {

  if(show) {
    $('.is-required-message').show();
  } else {
    $('.is-required-message').hide();
  }

}

function addMultistepFormError(key) {
  
  var errorMessage = $('.step-error-messages').attr('data-' + key);

  if($('.message.fromJS').length <= 0) {
    $('.error-container').append('<div class="form-error-message message fromJS"> <p>' + errorMessage + '</p> </div>')
  }

}

function removeMultistepFormErrors() {

    $('.form-error-message.message').each(function(index, element) {
      $(element).remove();
    });

} 


//Form specific functions
function setupMultistepFormOtherFunctions() {

  //For publicContest
  $('.other-email').click(function() {

    removeMultistepFormErrors();
    $('.password-input').remove();
    $('.email').val("");

  });


  var hideInPublicContestMultistep = function() {
    
    $('.show-multistep-container').hide();
    $('.bigFooterContainer').hide();
    $('.footer').css('margin', 0);
    $('.sub-navbar').hide();
    $('#mainNavLine').hide();

    $('.multistepFormContainer').show();

  }

  $('.show-multistep').click(function() {

    hideInPublicContestMultistep();

  });

  $('.contest-version-switch').click(function() {

    hideInPublicContestMultistep();

    $('.contestVersionInput').val($(this).attr('data-appVersionVI'));
    $('.for-visually-impaired').show();

  });
  //For publicContest


}
